import React from 'react'
import styled from 'styled-components'
import P from '../../commons/P'
import Bold from '../../commons/Bold'
import {beUrl} from "../../../config";

const Intro = () => {

  return (
    <Container>
      <StyledP>
        Banca Sistema è lieta di presentarvi <Bold>PrestitoPuoi!</Bold>
      </StyledP>
      <StyledP>
        <Bold>PrestitoPuoi</Bold> è il servizio di Banca Sistema pensato per accompagnarti nella scelta del prestito personale più adatto, quindi liquidità pronto uso per realizzare diversi progetti, grazie a partnership con primari istituti e intermediari finanziari.
      </StyledP>
      <StyledP>
        Con le soluzioni che ti saranno illustrate utilizzando la piattaforma PrestitoPuoi potrai decidere senza pensieri di arredare casa, acquistare una nuova auto o l’ultimo modello della tua moto preferita. Ma anche prenotare un viaggio o pianificare un grande evento della tua vita…un matrimonio, una cerimonia per la laurea di tuo figlio, un’occasione speciale. Oppure potrai anche gestire più comodamente le tue spese di famiglia, di natura medica o legale.
      </StyledP>
      <StyledP>
          Attraverso  <Bold>PrestitoPuoi,</Bold> il cliente viene accompagnato lungo tutto il percorso di accesso al credito, dalla prima richiesta fino alla scelta della soluzione più coerente con le proprie esigenze.
      </StyledP>
      <StyledP>
        Cosa aspetti a contattarci?
      </StyledP>
        <A href={`${beUrl}/landing-prestitopuoi`}>
            RICHIEDI QUI UNA PROPOSTA PERSONALIZZATA
        </A>
    </Container>
  )
}

// region Style
const Container = styled.div`
  max-width: 1125px;
  @media (min-width: 993px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  margin: 7rem auto 0 auto;
  padding-left: 1.10294rem;
  padding-right: 1.10294rem;
  display: block;
`
const StyledP = styled(P)`
  text-align: left;
`
const A = styled.a`
    background-color: #222222;
    font-size: 16px;
    color: #fff;
    letter-spacing: 0;
    position: relative;
    font-weight: 700;
    text-decoration: none;
    line-height: 1;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    transition: all 0.1s ease-out;
    border-radius: 2.3rem;
    min-height: 4.6rem;
    padding: 1rem 3rem;
    border: none;
`
// endregion

export default Intro
